import { createApi } from '@core/fetch'
// 盘古项目新增api
export default {
  // 获取店铺是否激活
  getStoreJumpMode: createApi(
    '/hms/hljMerchantCenter/appApi/merchant/store/jump/mode'
  ),
  // 记录企业跳转盘古状态
  recordStoreJumpMode: createApi(
    '/hms/hljMerchantCenter/appApi/merchant/admin/recordStoreJumpMode'
  )
}
